import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-icon-next',
	templateUrl: './next.component.html',
	styleUrls: ['./next.component.scss']
})
export class NextIconComponent {}
